module.exports = __webpack_public_path__ + "static/media/31.8b918c79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/31.jpg
// module id = 291
// module chunks = 0